<template>
  <div class="panel granary-panel">
    <div class="chart-box">
      <div ref="chart" class="chart"></div>
    </div>
  </div>
</template>

<script>
import { loadChart } from "./charts/scpclData";
import { findQueryList } from "@/api/granary";
export default {
  data() {
    return {};
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.chart = this.$echarts.init(this.$refs.chart);
      findQueryList({
        code: "cldb"
      }).then(res => {
        const data = res.data;
        if (data instanceof Array) {
          let slist = [];
          let line = [];
          data.forEach(ele => {
            slist.push(ele.name);
            line.push(Number(ele.cl));
          });
          loadChart(this.chart, slist, line);
        }
      });

      // const slist = ["茂南区", "电白区", "信宜市", "高州市", "化州市"];
      // const line = [37464, 646730, 31241, 84566, 122168];
      // loadChart(this.chart, slist, line);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  width 100%
  .chart-box
    width 100%
    height 100%
</style>
